import React from 'react';
import Header from './Common/header';
import './css/index';

export default class Content_19 extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@56lhvi`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div style={{ textAlign: 'center' }}>
                                    <div>
                                        <a href="javascript:void(0);">
                                            <img src="http://image.sinajs.cn/newchart/min/n/sh000001.gif" border="0" style={{ width: '300px', height: '165px' }} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_19.js